import { Component, Input } from '@angular/core';

import { NotificationsService } from './notifications.service';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent {
  @Input()
  notification: any;

  constructor(private notificationsService: NotificationsService) {}

  onNotificationClick(notification: any) {
    this.notificationsService.updateNotification(notification, { read: true });
  }

  get defaultImageUrl(): string {
    return '//storage.googleapis.com/ttc-static-images/profile-photo/account-A17408D95D399D2C5A6E0AA766E521F0.png';
  }
}
